<template>
  <div>
    <div
      id="create-content-container"
      :class="{ 'tour-overlay-active': isTourOverlay }"
    >
      <iframe
        frameborder="0"
        width="100%"
        scrolling="no"
        :src="iframeSrc"
        allow="clipboard-read; clipboard-write; downloads"
        :height="height"
        @load="onIframeLoad"
      />
    </div>

    <!-- Backdrop tour: menggelapkan sidebar + header shell yang ada di luar
         iframe. Area iframe digelapkan oleh mask milik partner-v2; iframe
         dinaikkan di atas backdrop ini supaya spotlight-nya tetap tembus. -->
    <div
      v-if="isTourOverlay"
      class="tour-shell-backdrop"
    />

    <ModalTopupKomedSuccess
      v-model="isShowTopupSuccessModal"
      modal-id="modal-topup-success-create-content"
      :transaction="topupSuccessData"
      @close="closeTopupSuccessModal"
      @download="downloadReceipt"
      @history="navigateToHistory"
    />
    <DrawerTopupKreditKomed
      v-model="isOpenTopupDrawer"
      drawer-id="drawer-topup-kredit-komed-create-content"
      width="460px"
      :balance="currentBalance"
      :submit-loading="isSubmittingTopup"
      @submit="submitTopup"
      @close="closeTopupDrawer"
      @open="fetchKompayBalance"
      @hidden="closeTopupDrawer"
    />
    <ModalConfirm
      id="modal-no-product-create-content"
      title="Belum Punya Produk?"
      message="Silahkan tambah produk terlebih dahulu sebelum mulai untuk generate video."
    >
      <template #icon>
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt="Warning"
          width="100"
          height="100"
        >
      </template>
      <template #footer>
        <b-button
          variant="primary"
          block
          style="border-radius: 8px; width: 100%;"
          @click="openModalTambahProduk"
        >
          Tambah Produk
        </b-button>
      </template>
    </ModalConfirm>

    <ModalTambahProdukBuatKonten
      modal-id="modal-tambah-produk-create-content"
      :is-create-lite="isCreateLiteModal"
      @product-saved="onProductSaved"
      @refetch-iframe="onIframeLoad"
    />

    <ModalPreviewVideo
      modal-id="modal-preview-video-create-content"
      :video-url="previewVideoUrl"
      @hidden="previewVideoUrl = ''"
    />

    <ModalPreviewImage
      modal-id="modal-preview-image-create-content"
      :image-url="previewImageUrl"
      @hidden="previewImageUrl = ''"
    />

    <ModalDeleteKonten
      modal-id="modal-delete-konten"
      :video="selectedDeleteVideo"
      @success="handleDeleteSuccess"
    />
    <ModalSuccessDeleteKonten
      modal-id="modal-success-delete-konten"
    />
    <ModalInsufficientCreditBuatKonten
      modal-id="modal-insufficient-credit-create-content"
      @topup="openTopupDrawer"
    />
    <ModalInsufficientCreditViralClone
      modal-id="modal-insufficient-credit-viral-clone"
      @topup="openTopupDrawer"
    />
    <ModalConfirmGantiProduk
      modal-id="modal-confirm-ganti-produk-viral-clone"
      @confirm="onConfirmGantiProduk"
      @cancel="onCancelGantiProduk"
    />
    <ModalConfirmHapusHasilAnalisis
      modal-id="modal-confirm-hapus-hasil-analisis-viral-clone"
      :trigger="pendingHapusHasilAnalisisData ? (pendingHapusHasilAnalisisData.trigger || 'toggle') : 'toggle'"
      :title="pendingHapusHasilAnalisisData ? (pendingHapusHasilAnalisisData.title || '') : ''"
      :message="pendingHapusHasilAnalisisData ? (pendingHapusHasilAnalisisData.message || '') : ''"
      :confirm-text="pendingHapusHasilAnalisisData ? (pendingHapusHasilAnalisisData.confirmText || '') : ''"
      :cancel-text="pendingHapusHasilAnalisisData ? (pendingHapusHasilAnalisisData.cancelText || '') : ''"
      @confirm="onConfirmHapusHasilAnalisis"
      @cancel="onCancelHapusHasilAnalisis"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalConfirm from '@/views/components/modal/ModalConfirm.vue'
import DrawerTopupKreditKomed from '../components/DrawerTopupKreditKomed.vue'
import ModalTopupKomedSuccess from '../components/ModalTopupKomedSuccess.vue'
import ModalTambahProdukBuatKonten from '../components/ModalTambahProdukBuatKonten.vue'
import ModalDeleteKonten from '../components/ModalDeleteKonten.vue'
import ModalSuccessDeleteKonten from '../components/ModalSuccessDeleteKonten.vue'
import ModalInsufficientCreditBuatKonten from '../components/ModalInsufficientCreditBuatKonten.vue'
import ModalInsufficientCreditViralClone from '../components/ModalInsufficientCreditViralClone.vue'
import ModalConfirmGantiProduk from '../components/ModalConfirmGantiProduk.vue'
import ModalConfirmHapusHasilAnalisis from '../components/ModalConfirmHapusHasilAnalisis.vue'
import ModalPreviewImage from '../components/ModalPreviewImage.vue'
import ModalPreviewVideo from '../components/ModalPreviewVideo.vue'

export default {
  components: {
    DrawerTopupKreditKomed,
    ModalTopupKomedSuccess,
    ModalConfirm,
    ModalTambahProdukBuatKonten,
    ModalDeleteKonten,
    ModalSuccessDeleteKonten,
    ModalInsufficientCreditBuatKonten,
    ModalInsufficientCreditViralClone,
    ModalConfirmGantiProduk,
    ModalConfirmHapusHasilAnalisis,
    ModalPreviewImage,
    ModalPreviewVideo,
  },
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      initialSearch: window.location.search || '',
      height: 400,
      previewVideoUrl: '',
      previewImageUrl: '',
      isOpenTopupDrawer: false,
      isShowTopupSuccessModal: false,
      isShowNoProductModal: false,
      isSubmittingTopup: false,
      currentBalance: 0,
      pendingGantiProdukData: null,
      topupSuccessData: {
        transactionId: null,
        email: null,
        nominal: 0,
        timestamp: null,
      },
      isCreateLiteModal: true,
      selectedDeleteVideo: null,
      isTourOverlay: false,
      isViralCloneActive: false,
      pendingRouteLeave: null,
      pendingHapusHasilAnalisisData: null,
    }
  },
  computed: {
    ...mapState('saldo', {
      saldoKompay: 'saldo',
    }),
    ...mapState('auth', {
      authUserData: 'userData',
    }),
    iframeSrc() {
      return `${this.VUE_APP_BASE_AUTH_MODULE}/komed/content/create-content${this.initialSearch}`
    },
    iframeOrigin() {
      try {
        return new URL(this.VUE_APP_BASE_AUTH_MODULE).origin
      } catch {
        return this.VUE_APP_BASE_AUTH_MODULE
      }
    },
    userEmail() {
      return this.authUserData?.email || this.authUserData?.partner_email || ''
    },
    userId() {
      return this.authUserData?.id || this.authUserData?.user_id || null
    },
  },
  watch: {
    '$route.query.tab': {
      handler(newTab) {
        this.notifyIframeTabChange(newTab || '')
      },
    },
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
    this.fetchKompayBalance()

    if (this.$route?.query?.openTopup === '1') {
      this.openTopupDrawer()
    }
  },
  beforeRouteLeave(to, from, next) {
    const isUgcTab = !from.query?.tab || from.query?.tab === 'ugc'
    if (this.isViralCloneActive && isUgcTab) {
      this.pendingRouteLeave = next
      this.pendingHapusHasilAnalisisData = { trigger: 'navigation' }
      this.$bvModal.show('modal-confirm-hapus-hasil-analisis-viral-clone')
      return
    }
    next()
  },
  beforeDestroy() {
    this.cleanup()
  },
  unmounted() {
    this.cleanup()
  },
  methods: {
    notifyIframeTabChange(tab) {
      const iframe = document.querySelector('#create-content-container iframe')
      if (!iframe?.contentWindow) return

      iframe.contentWindow.postMessage({
        type: 'TAB_CHANGED',
        data: { tab },
      }, this.iframeOrigin)
    },
    async fetchKompayBalance() {
      try {
        await this.$store.dispatch('saldo/getBalanceSummary')
        this.currentBalance = Number(this.saldoKompay || 0)
      } catch (error) {
        console.error('Gagal fetch saldo Kompay:', error)
        this.currentBalance = Number(this.currentBalance || 0)
      }
    },
    cleanup() {
      window.removeEventListener('message', this.watchIframe)
      this.isTourOverlay = false
    },
    onIframeLoad() {
      this.sendMessage('refetch')
    },
    watchIframe(event) {
      if (event.origin !== this.iframeOrigin) return

      const {
        type,
        data,
        route,
        modal,
      } = event.data || {}

      const handlers = {
        SET_DIMENSION: () => {
          this.height = Math.max(Math.floor(data?.height || 0), 400)
        },
        // Guide tour partner-v2 aktif/selesai. Mask antd di dalam iframe tidak
        // bisa menutupi sidebar/header shell, jadi host menggelapkan sendiri.
        TOUR_OVERLAY: () => {
          this.isTourOverlay = Boolean(data?.active)
        },
        // Auto-scroll saat tour pindah step. Iframe pakai scrolling="no" dan
        // tingginya diset penuh via SET_DIMENSION, jadi scrollIntoView di dalam
        // iframe tidak berefek — viewport yang sebenarnya scroll ada di host ini.
        TOUR_SCROLL_TO: () => {
          if (typeof data?.top !== 'number') return

          const iframe = document.querySelector('#create-content-container iframe')
          const iframeTop = iframe
            ? iframe.getBoundingClientRect().top + window.scrollY
            : 0

          window.scrollTo({ top: Math.max(0, iframeTop + data.top), behavior: 'smooth' })
        },
        OPEN_TOPUP_BUAT_KONTEN: () => {
          this.currentBalance = Number(data?.currentBalance || this.currentBalance)
          this.openTopupDrawer()
        },
        MODAL_TOPUP_BUAT_KONTEN: () => {
          this.currentBalance = Number(data?.currentBalance || this.currentBalance)
          this.openTopupDrawer()
        },
        CLOSE_TOPUP_BUAT_KONTEN: () => {
          this.closeTopupDrawer()
        },
        MODAL_NO_PRODUCT: () => {
          this.isCreateLiteModal = true
          this.$bvModal.show('modal-no-product-create-content')
        },
        OPEN_MODAL_TAMBAH_PRODUK: () => {
          if (data && data.isCreateLite !== undefined) {
            this.isCreateLiteModal = data.isCreateLite
          }
          this.$bvModal.hide('modal-no-product-create-content')
          this.$bvModal.show('modal-tambah-produk-create-content')
        },
        OPEN_DELETE_KONTEN_MODAL: () => {
          this.selectedDeleteVideo = data
          this.$bvModal.show('modal-delete-konten')
        },
        OPEN_INSUFFICIENT_CREDIT_MODAL: () => {
          this.$bvModal.show('modal-insufficient-credit-create-content')
        },
        OPEN_INSUFFICIENT_CREDIT_VIRAL_CLONE_MODAL: () => {
          this.$bvModal.show('modal-insufficient-credit-viral-clone')
        },
        MODAL_INSUFFICIENT_CREDIT_VIRAL_CLONE: () => {
          this.$bvModal.show('modal-insufficient-credit-viral-clone')
        },
        OPEN_MODAL_GANTI_PRODUK: () => {
          this.pendingGantiProdukData = data
          this.$bvModal.show('modal-confirm-ganti-produk-viral-clone')
        },
        MODAL_CONFIRM_GANTI_PRODUK: () => {
          this.pendingGantiProdukData = data
          this.$bvModal.show('modal-confirm-ganti-produk-viral-clone')
        },
        OPEN_MODAL_HAPUS_HASIL_ANALISIS: () => {
          this.pendingHapusHasilAnalisisData = data
          this.$bvModal.show('modal-confirm-hapus-hasil-analisis-viral-clone')
        },
        VIRAL_CLONE_STATE_CHANGED: () => {
          this.isViralCloneActive = Boolean(data?.isViralClone)
        },
        MODAL_CONFIRM_HAPUS_HASIL_ANALISIS: () => {
          this.pendingHapusHasilAnalisisData = data
          this.$bvModal.show('modal-confirm-hapus-hasil-analisis-viral-clone')
        },
        OPEN_PREVIEW_VIDEO_MODAL: () => {
          this.previewVideoUrl = data?.file || data?.url || ''
          this.$bvModal.show('modal-preview-video-create-content')
        },
        OPEN_PREVIEW_IMAGE_MODAL: () => {
          this.previewImageUrl = data?.url || ''
          this.$bvModal.show('modal-preview-image-create-content')
        },
        // Fallback download dari iframe kalau fetch di child kena CORS.
        async DOWNLOAD_KONTEN_FILE() {
          const url = data?.url
          if (!url) return

          try {
            const response = await fetch(url)
            const blob = await response.blob()

            const href = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = href
            link.download = data?.filename || 'konten'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } catch (error) {
            console.error('Gagal download file:', error)
          }
        },
        // Backward compatibility if the embedded page still emits the Komed events.
        OPEN_TOPUP_KREDIT_KOMED: () => {
          this.currentBalance = Number(data?.currentBalance || this.currentBalance)
          this.openTopupDrawer()
        },
        MODAL_TOPUP_KREDIT_KOMED: () => {
          this.currentBalance = Number(data?.currentBalance || this.currentBalance)
          this.openTopupDrawer()
        },
        CLOSE_TOPUP_KREDIT_KOMED: () => {
          this.closeTopupDrawer()
        },
        UPDATE_TAB: () => {
          const tab = data?.tab || ''
          const query = { ...this.$route.query }
          if (tab) {
            query.tab = tab
          } else {
            delete query.tab
          }
          this.$router.replace({ query }).catch(() => {})
        },
      }

      if (handlers[type]) {
        handlers[type]()
      }

      if (handlers[modal]) {
        handlers[modal]()
      }

      if (route) {
        this.$router.push(route)
      }
    },
    openTopupDrawer() {
      this.fetchKompayBalance()
      this.isOpenTopupDrawer = true
    },
    closeTopupDrawer() {
      this.isOpenTopupDrawer = false
    },
    openModalTambahProduk() {
      this.isCreateLiteModal = true
      this.$bvModal.hide('modal-no-product-create-content')
      this.$bvModal.show('modal-tambah-produk-create-content')
    },
    handleDeleteSuccess() {
      this.$bvModal.show('modal-success-delete-konten')
      this.sendMessage('refetchKontenHistory')
    },
    async submitTopup({ nominal }) {
      if (!this.userEmail) {
        this.$toast_error({ message: 'Email user tidak ditemukan' })
        return
      }

      if (!this.userId) {
        this.$toast_error({ message: 'User ID tidak ditemukan' })
        return
      }

      this.isSubmittingTopup = true
      try {
        const response = await this.$http_new.post('/komed/api/v1/komed/topup', {
          user_id: this.userId,
          email: this.userEmail,
          nominal,
        })

        this.topupSuccessData = {
          transactionId: response?.data?.data?.transaction_code,
          email: this.userEmail,
          nominal,
          timestamp: new Date().toISOString(),
        }

        this.$toast_success({ message: 'Top up Buat Konten berhasil' })
        this.closeTopupDrawer()
        this.showTopupSuccessModal()
        this.fetchKompayBalance()
        this.sendMessage('refetch')
      } catch (error) {
        const message = error?.response?.data?.message || 'Top up Buat Konten gagal diproses'
        this.$toast_error({ message })
      } finally {
        this.isSubmittingTopup = false
      }
    },
    showTopupSuccessModal() {
      this.isShowTopupSuccessModal = true
    },
    closeTopupSuccessModal() {
      this.isShowTopupSuccessModal = false
    },
    downloadReceipt() {
      this.$toast_info({ message: 'Mengunduh bukti transaksi...' })
    },
    navigateToHistory() {
      this.closeTopupSuccessModal()
      this.$router.push({ path: '/komed/keuangan/riwayat-topup' })
    },
    sendMessage(param) {
      const message = {
        refetch: { type: 'REFETCH_GET_BUAT_KONTEN' },
        openTopup: { type: 'OPEN_TOPUP_BUAT_KONTEN' },
        closeTopup: { type: 'CLOSE_TOPUP_BUAT_KONTEN' },
        refetchKontenHistory: { type: 'REFETCH_KONTEN_HISTORY' },
      }

      const iframe = document.querySelector('#create-content-container iframe')
      if (!iframe?.contentWindow || !message[param]) return

      iframe.contentWindow.postMessage(message[param], this.iframeOrigin)
    },
    onProductSaved(productData) {
      const iframe = document.querySelector('#create-content-container iframe')
      if (!iframe?.contentWindow) return

      iframe.contentWindow.postMessage({
        type: 'PRODUCT_SAVED',
        data: productData,
      }, this.iframeOrigin)
    },
    onConfirmGantiProduk() {
      const iframe = document.querySelector('#create-content-container iframe')
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'CONFIRM_GANTI_PRODUK',
          data: this.pendingGantiProdukData,
        }, this.iframeOrigin)
      }
      this.pendingGantiProdukData = null
    },
    onCancelGantiProduk() {
      const iframe = document.querySelector('#create-content-container iframe')
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'CANCEL_GANTI_PRODUK',
        }, this.iframeOrigin)
      }
      this.pendingGantiProdukData = null
    },
    onConfirmHapusHasilAnalisis() {
      const iframe = document.querySelector('#create-content-container iframe')
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'CONFIRM_HAPUS_HASIL_ANALISIS',
        }, this.iframeOrigin)
      }
      this.pendingHapusHasilAnalisisData = null
      if (this.pendingRouteLeave) {
        const nextFn = this.pendingRouteLeave
        this.pendingRouteLeave = null
        this.isViralCloneActive = false
        nextFn()
      }
    },
    onCancelHapusHasilAnalisis() {
      const iframe = document.querySelector('#create-content-container iframe')
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'CANCEL_HAPUS_HASIL_ANALISIS',
        }, this.iframeOrigin)
      }
      this.pendingHapusHasilAnalisisData = null
      if (this.pendingRouteLeave) {
        this.pendingRouteLeave(false)
        this.pendingRouteLeave = null
      }
    },
  },
}
</script>

<style scoped>
/* Sidebar `.main-menu` z-index 1031, `_sidebar.scss` 1036, navbar 997.
   Backdrop harus di atas semuanya, iframe di atas backdrop supaya mask +
   spotlight milik partner-v2 tetap terlihat. Tetap di bawah BModal (1050+)
   supaya modal host yang dipicu iframe masih tampil di atas tour. */
.tour-shell-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(0, 0, 0, 0.5);
}

#create-content-container.tour-overlay-active {
  position: relative;
  z-index: 1041;
}
</style>
